import { RouteRecordRaw } from 'vue-router';
import { GenerateRecordPage } from '@/pages/record-fill';

export const routeName = 'VisualizarRegistro';

// No permission beyond seeing the record: the form read answers 404 outside the code folder.
export const route: RouteRecordRaw = {
  path: 'registros-da-qualidade/:prefix/ver-registro/:recordId',
  name: routeName,
  component: GenerateRecordPage,
  meta: { requiresAuth: true },
};
